
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"criterionCardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoAboutCriterionCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"criterionCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"criterionCardId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useReducedPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useStandardReducedPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reducedPriceFormula"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionCardType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterias"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationFormula"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoreDirection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criteriaMark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"measuringUnit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitShortTitle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"decimals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formulaCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionControlType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDisplayed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dynamicCriterions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetCriterionMark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparingMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetCriterionTitle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBestValueDisplayedWeb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionKind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criterionBindingLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fixedValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"standartValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dictionaryValues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"useInRedFormula"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1021}};
    doc.loc.source = {"body":"query($criterionCardId: Int) {\n  infoAboutCriterionCard(criterionCardId: $criterionCardId){\n    id\n    title\n    useReducedPrice\n    useStandardReducedPrice\n    reducedPriceFormula\n    criterionCardType\n    criterias {\n      calculationFormula\n      scoreDirection\n      criteriaMark\n      measuringUnit {\n        unitId\n        unitCode\n        unitTitle\n        unitShortTitle\n      }\n      description\n      decimals\n      totalLength\n      formulaCode\n      criterionControlType\n      id\n      criterionCode\n      title\n      required\n      isDisplayed\n      dynamicCriterions {\n        id\n        criterionId\n        criterionCode\n        value\n        targetCriterionMark\n        comparingMode\n        targetCriterionTitle\n      }\n      number\n      isBestValueDisplayedWeb\n      minValue\n      maxValue\n      attachmentMode\n      criterionKind\n      criterionBindingLevel\n      fixedValue\n      standartValue\n      dictionaryValues {\n        id\n        title\n        score\n      }\n      useInRedFormula\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
